import { DialogContent, List, ListItemText, ListItemButton, useMediaQuery, useTheme } from "@mui/material";
import { MeetingDialogTitle } from "../widgets";
import StageDialog from "../StageDialog";
import { getBrowserIcon, isBrowserSupported, useDebugSettings } from "conference/tools";
import { getSipConferenceNumbers, getTelConferenceNumbers } from "../../joinMeetingTools";
import SipPhoneIcon from "./SipPhoneIcon";
import AutoNestedListItem from "./AutoNestedListItem";
import { useSettings } from "../tools";
import { ConcertoClientListItem, ListIcon, ListIconContainer } from "./listWidgets";
import { FormattedMessage } from "react-intl";

const ClientSelectorContainer = () => {
    const telNumbers = getTelConferenceNumbers();
    const sipNumbers = getSipConferenceNumbers();
    const settings = useSettings();
    const debugSettings = useDebugSettings();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const browserClientEnabled =
        isDesktop && (isBrowserSupported || (debugSettings.enabled && debugSettings.enableAllBrowsers));

    return (
        <StageDialog>
            <MeetingDialogTitle />
            <DialogContent
                sx={{
                    minWidth: 400,
                    padding: "1.2em",
                    [theme.breakpoints.down("sm")]: {
                        padding: "1.2em 0",
                        minWidth: "unset",
                    },
                }}
            >
                <>
                    <List style={{ padding: 0 }}>
                        <ConcertoClientListItem />
                        <AutoNestedListItem
                            label={<FormattedMessage id="meetingPage.clientSelector.phone" defaultMessage="Phone" />}
                            icon={<ListIcon icon="phone" />}
                            itemPrefix="tel:"
                            items={telNumbers}
                        />
                        <AutoNestedListItem
                            label={
                                <FormattedMessage
                                    id="meetingPage.clientSelector.sipClient"
                                    defaultMessage="SIP Client"
                                />
                            }
                            icon={
                                <ListIconContainer>
                                    <SipPhoneIcon />
                                </ListIconContainer>
                            }
                            itemPrefix="sip:"
                            items={sipNumbers}
                        />
                        {browserClientEnabled && (
                            <ListItemButton
                                onClick={() => settings.update((current) => ({ ...current, stage: current.stage + 1 }))}
                            >
                                <ListIcon icon={{ prefix: "fab", iconName: getBrowserIcon() }} />
                                <ListItemText
                                    primary={
                                        <FormattedMessage
                                            id="meetingPage.clientSelector.browser"
                                            defaultMessage="Browser"
                                        />
                                    }
                                    secondary={
                                        <FormattedMessage
                                            id="meetingPage.clientSelector.browserDesc"
                                            defaultMessage="Join from your browser"
                                        />
                                    }
                                />
                            </ListItemButton>
                        )}
                    </List>
                </>
            </DialogContent>
        </StageDialog>
    );
};

export default ClientSelectorContainer;
